import React, { HTMLAttributes, PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";

export function SubHeader(
  props: PropsWithChildren<HTMLAttributes<HTMLSpanElement>>,
) {
  const { className, children, ...others } = props;
  return (
    <span
      className={twMerge("font-sans text-space-cadet", className)}
      {...others}
    >
      {children}
    </span>
  );
}
